exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".processcippage-cssmodule-processcippage-component-1nqg0{border:1px dashed red;border:none}.processcippage-cssmodule-form-container-16AHB{padding-top:10px}", ""]);

// exports
exports.locals = {
	"processcippage-component": "processcippage-cssmodule-processcippage-component-1nqg0",
	"form-container": "processcippage-cssmodule-form-container-16AHB"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/ProcessIdeas/processcippage.cssmodule.scss
// module id = 607
// module chunks = 0